import http from "./http";

export async function listNotifications(limit = 50) {
  const { data } = await http.get("/api/notifications", { params: { limit } });
  return data;
}

export async function markNotificationAsRead(id) {
  const { data } = await http.post(`/api/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsAsRead() {
  const { data } = await http.post("/api/notifications/read-all");
  return data;
}

export async function deleteNotification(id) {
  const { data } = await http.delete(`/api/notifications/${id}`);
  return data;
}

export async function clearAllNotifications() {
  const { data } = await http.delete("/api/notifications");
  return data;
}
